import { ReactElement, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';
import HelpBar, {
	Main,
} from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';
import Typography from '@mui/material/Typography';
import FormLayout from 'layouts/FormLayout';
import HelpLayout from 'layouts/HelpLayout';
import ReassignForm from './ReassignForm';

/**
 * Page where manager can reassign a non-employee to a new manager
 * @returns {ReactElement} User Access Review Employee Reassign page view
 */
const ReassignView = () => {
	const [sOpen, setOpen] = useState(false);
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Reassign User To New Manager'}
			CurrentPageIcon={PAGE_ICONS.REASSIGN}
		>
			<CssBaseline />
			<Main open={sOpen}>
				<FormLayout
					title={'Reassign User To New Manager'}
					setOpen={() => setOpen(!sOpen)}
				>
					<ReassignForm open={sOpen} />
				</FormLayout>
			</Main>
			<HelpBar open={sOpen} setOpen={setOpen}>
				<HelpLayout title='Reassign User To New Manager'>
					<Typography>
						Allows for manager reasignment for non-employees.
					</Typography>
					<br></br>
					<Typography>
						For more information, please check on{' '}
						<a
							target='_blank'
							rel='noopener noreferrer'
							href='https://infonet.upmc.com/infonet/ls/content/6236583790140711/annual-user-access-review-guide-pdf-1764799965'
						>
							InfoNet
						</a>
					</Typography>
				</HelpLayout>
			</HelpBar>
		</PageWithBreadcrumbs>
	);
};

export default ReassignView;
